import { render, staticRenderFns } from "./preferentialStatistics.vue?vue&type=template&id=f5c7889e&scoped=true&"
import script from "./preferentialStatistics.vue?vue&type=script&lang=js&"
export * from "./preferentialStatistics.vue?vue&type=script&lang=js&"
import style0 from "./preferentialStatistics.vue?vue&type=style&index=0&id=f5c7889e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c7889e",
  null
  
)

export default component.exports